/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBluetoothX = createReactComponent("outline", "bluetooth-x", "IconBluetoothX", [["path", { "d": "M7 8l10 8l-5 4v-16l1 .802m0 6.396l-6 4.802", "key": "svg-0" }], ["path", { "d": "M16 6l4 4", "key": "svg-1" }], ["path", { "d": "M20 6l-4 4", "key": "svg-2" }]]);

export { IconBluetoothX as default };
//# sourceMappingURL=IconBluetoothX.mjs.map
